import { useEditor } from '../state/store';
import { getTool } from '../tools/registry';
import { BRAILLE_COLS, BRAILLE_ROWS } from '../unicode/braille';

/** Status line: where the cursor is, what the document is, what the tool is. */
export function StatusBar(): JSX.Element {
  const cursor = useEditor((s) => s.cursor);
  const toolId = useEditor((s) => s.tool);
  const zoom = useEditor((s) => s.renderOptions.zoom);
  const previewMode = useEditor((s) => s.renderOptions.previewMode);
  const revision = useEditor((s) => s.revision);
  const historyState = useEditor((s) => s.historyState);
  const tab = useEditor.getState().active();
  const tool = getTool(toolId);
  const isBraille = toolId.startsWith('braille');

  return (
    <footer className="statusbar" key={revision}>
      <span className="chip">
        <span>xy</span>
        <b>{cursor ? `${cursor.x},${cursor.y}` : '—'}</b>
      </span>
      {isBraille && cursor ? (
        <span className="chip">
          <span>dot</span>
          <b>
            {cursor.x * BRAILLE_COLS},{cursor.y * BRAILLE_ROWS}
          </b>
        </span>
      ) : null}
      <span className="chip">
        <span>size</span>
        <b>
          {tab.doc.width}×{tab.doc.height}
        </b>
      </span>
      <span className="chip">
        <span>colour</span>
        <b>{tab.doc.colorMode}</b>
      </span>
      <span className="chip">
        <span>preview</span>
        <b>{previewMode}</b>
      </span>
      <span className="chip">
        <span>utf-8</span>
      </span>
      <span className="chip">
        <span>tool</span>
        <b>{tool.name}</b>
      </span>
      <span className="chip">
        <span>layer</span>
        <b>{tab.doc.activeLayer.name}</b>
      </span>
      {tab.selection.size > 0 ? (
        <span className="chip">
          <span>selected</span>
          <b>{tab.selection.size}</b>
        </span>
      ) : null}
      <span className="spacer" />
      <span className="chip">
        <span>history</span>
        <b>{historyState.depth}</b>
      </span>
      <span className="chip">
        <span>zoom</span>
        <b>{Math.round(zoom * 100)}%</b>
      </span>
    </footer>
  );
}
